import React from 'react'
import { Switch, type SwitchProps } from '@mantine/core'

export type AppSwitchProps = SwitchProps

export default function AppSwitch (props: AppSwitchProps) {
  return <Switch {...props} />
}
